module.exports = __webpack_public_path__ + "static/media/fileTemplate.00e2723f.xlsx";